import React, { useState, useEffect, useRef } from "react"
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom"
import {
  Row,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Spinner,
  FormGroup,
  InputGroup,
  Button,
  Input,
  Label
} from "reactstrap"
import DatePicker from "react-datepicker";
import { getAllCustomers as onGetAllCustomers } from "store/products/actions"
import Select from "react-select"
import * as moment from "moment"
import "react-datepicker/dist/react-datepicker.css";

const SalesListFilter = props => {
  
  const dispatch = useDispatch()
  const [showFilter, setShowFilter] = useState(false)
  const [filterApplied, setFilterApplied] = useState(false)
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState(null)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [searchCriteria, setSearchCriteria] = useState({})
  const [searchDispCriteria, setSearchDispCriteria] = useState({
    customername: 'All',
    status : 'Any'
  })
  const [searchDispCriteriaTemp, setSearchDispCriteriaTemp] = useState({
    customername: 'All',
    status : 'Any'
  })

  useEffect(() => {
    if(props.filterApplied != undefined){
      setFilterApplied(props.filterApplied)
    }
    if(props.searchCriteria){
      setSearchCriteria(props.searchCriteria)
      if(props.searchCriteria.customerid){
        const selectedCust = customerList.filter(each => each.value ==props.searchCriteria.customerid)
        if(selectedCust.length > 0){
          setSelectedCustomer(selectedCust[0])
        }
      }

      if(props.searchCriteria.status){
        const selectedStatus = statusOptions.filter(each => each.value ==props.searchCriteria.status)
        if(selectedStatus.length > 0){
          setSelectedStatus(selectedStatus[0])
        }
      }

      if(props.searchCriteria.startdate){
        setStartDate(new Date(props.searchCriteria.startdate))
      }
      if(props.searchCriteria.enddate){
        setEndDate(new Date(props.searchCriteria.enddate))
      }

    }
    if(props.searchDispCriteria){
      setSearchDispCriteria(props.searchDispCriteria)
      setSearchDispCriteriaTemp(props.searchDispCriteria)
    }
  }, [props]);

  useEffect(() => {
    dispatch(onGetAllCustomers(true))
  }, [dispatch]);

  /*
  useEffect(() => {
    console.log('searchCriteria:'+JSON.stringify(searchCriteria))
  }, [searchCriteria]);
  */

  const { customerList} = useSelector(state => ({
    customerList: state.Products.customers
  }))

  function handleSearch(){
    props.onSearch(searchCriteria)
    setFilterApplied(true)
    setShowFilter(false)
    setSearchDispCriteria({
      customername: searchDispCriteriaTemp.customername,
      status : searchDispCriteriaTemp.status,
      invoiceno : searchDispCriteriaTemp.invoiceno,
      startdate : searchDispCriteriaTemp.startdate,
      enddate : searchDispCriteriaTemp.enddate,
    })

    props.setSearchDispCriteria({
      customerid: searchDispCriteriaTemp.customername,
      customername: searchDispCriteriaTemp.customername,
      status : searchDispCriteriaTemp.status,
      invoiceno : searchDispCriteriaTemp.invoiceno,
      startdate : searchDispCriteriaTemp.startdate,
      enddate : searchDispCriteriaTemp.enddate,
    })

    props.setFilterApplied(true)
  }

  function handleClear(){
    //setFilterApplied(false)
    setSelectedCustomer(null)
    setSelectedStatus(null)
    setStartDate()
    setEndDate()
    setSearchCriteria({})
    setSearchDispCriteriaTemp({
      customername: 'All',
      status : 'Any'
    })

    //props.onSearch({})
  }

  const statusOptions = [
    {
      label: "Any",
      value: "any"
    },{
      label: "Paid",
      value: "paid"
    },{
      label: "Open",
      value: "open"
    },{
      label: "Draft",
      value: "draft"
    },{
      label: "Overdue",
      value: "overdue"
    }
  ]

  return (
    <Row className="mx-0 no-gutters">
      <Col lg="10" className="bg-light-grey mb-2 py-2 ps-2">
        {filterApplied && <>
        {searchDispCriteria.customername && searchDispCriteria.customername != '' && 
        <div className="text-truncate">Customer : <span className="font-size-13 fw-bold">{searchDispCriteria.customername}</span></div>}
        {searchDispCriteria.status && searchDispCriteria.status != '' && 
        <div className="text-truncate">Status   : <span className="font-size-13 fw-bold">{searchDispCriteria.status}</span></div>}
        {searchDispCriteria.invoiceno && searchDispCriteria.invoiceno != '' && 
        <div className="text-truncate">Invoice # : <span className="font-size-13 fw-bold">{searchDispCriteria.invoiceno}</span></div>}
        {((searchDispCriteria.startdate && searchDispCriteria.startdate != '') || (searchDispCriteria.enddate && searchDispCriteria.enddate != '') )&&
        <div className="text-truncate">Date     : <span className="font-size-13 fw-bold">{searchDispCriteria.startdate}{" - "}{searchDispCriteria.enddate}</span></div>}
      </>}
        {!filterApplied && <div className="text-center pt-2 font-size-14">All Transactions</div>}
      </Col>
      <Col lg="2" className="bg-light-grey text-center mb-2 py-2 ">
        {props.searchInProgress ? <Spinner style={{ width: '2rem', height: '2rem' }} className="my-1 " color="primary" /> : 
        <Dropdown
          className="d-lg-inline-block"
          isOpen={showFilter}
          toggle={() => {
            setShowFilter(!showFilter)
          }}
        >
          <DropdownToggle
            className="btn noti-icon "
            tag="button"
          >
            <i className="bx bx-filter-alt" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
            <div className="px-lg-2">
              <Row className="no-gutters">
                <Col>
                  <FormGroup className="mb-2">
                    <Label>Customer</Label>
                      <Select
                        onChange={(e) => {
                          setSelectedCustomer(e)
                          setSearchCriteria({
                            ...searchCriteria,
                            customerid : e.value //id for search
                          })
                          setSearchDispCriteriaTemp({
                            ...searchDispCriteriaTemp,
                            customername : e.label, //name for disp
                          })
                        }}
                        value={selectedCustomer}
                        options={customerList}
                        classNamePrefix="select2-selection"
                        isLoading={false}
                        id="productcustomer"
                      />
                  </FormGroup>
                </Col>
              </Row>

              <Row className="no-gutters">
                <Col>
                  <FormGroup className="mb-2">
                    <Label>Status</Label>
                      <Select
                        onChange={(e) => {
                          setSelectedStatus(e)
                          setSearchCriteria({
                            ...searchCriteria,
                            status : e.value
                          })
                          setSearchDispCriteriaTemp({
                            ...searchDispCriteriaTemp,
                            status : e.label
                          })
                        }}
                        value={selectedStatus}
                        options={statusOptions}
                        classNamePrefix="select2-selection"
                      />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="no-gutters">
                <Col>
                  <FormGroup className="mb-2">
                    <Label>Invoice #</Label>
                    <Input
                      type="text"
                      className="form-control"
                      value={searchCriteria.invoiceno || ''}
                      onChange={e => {
                        setSearchCriteria({
                          ...searchCriteria,
                          invoiceno : e.target.value
                        })
                        setSearchDispCriteriaTemp({
                          ...searchDispCriteriaTemp,
                          invoiceno : e.target.value
                        })
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="no-gutters">
                <Col>
                  <FormGroup className="mb-3">
                    <Label>Invoice Date Range</Label><br/>

                    <div className="d-flex">
                      <DatePicker
                        maxDate={new Date()}
                        selected={startDate}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        isClearable
                        onChange={date => {
                          setStartDate(date)
                          if(date){
                            const date1 = moment(new Date(date)).format("yyyy-MM-DD")
                            setSearchCriteria({
                              ...searchCriteria,
                              startdate : date1
                            })
                            setSearchDispCriteriaTemp({
                              ...searchDispCriteriaTemp,
                              startdate : moment(new Date(date)).format("DD/MMM/yyyy")
                            })
                          }
                          else{
                            setSearchCriteria({
                              ...searchCriteria,
                              startdate : date
                            })
                            setSearchDispCriteriaTemp({
                              ...searchDispCriteriaTemp,
                              startdate : ''
                            })
                          }
                        }}
                        dateFormat="dd/MMM/yyyy"
                      />
                      <DatePicker
                        maxDate={new Date()}
                        selected={endDate}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        isClearable
                        minDate={startDate}
                        onChange={date => {
                          setEndDate(date)
                          if(date){
                            const date1 = moment(new Date(date)).format("yyyy-MM-DD")
                            setSearchCriteria({
                              ...searchCriteria,
                              enddate : date1
                            })
                            setSearchDispCriteriaTemp({
                              ...searchDispCriteriaTemp,
                              enddate : moment(new Date(date)).format("DD/MMM/yyyy")
                            })
                          }
                          else{
                            setSearchCriteria({
                              ...searchCriteria,
                              enddate : date
                            })
                            setSearchDispCriteriaTemp({
                              ...searchDispCriteriaTemp,
                              enddate : ''
                            })
                          }
                        }}
                        dateFormat="dd/MMM/yyyy"
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              <Row className="no-gutters mb-2">
                <Col lg="7" className="text-center">
                  <Button color="primary" className="btn btn-md btn-block w-lg btn-primary" onClick={() => {
                      handleSearch()
                    }}
                    >
                    <i className="bx bx-search-alt me-1"></i>
                    Search
                  </Button>
                </Col>
                <Col lg="5" className="text-center">
                  <Button className="btn btn-md btn-block" onClick={() => {
                      handleClear()
                    }}
                    >
                    <i className="bx bx-undo me-1"></i>
                    Clear
                  </Button>
                </Col>
              </Row>

            </div>
          </DropdownMenu>
        </Dropdown>
        }
      </Col>
      
    </Row>
  )
}

SalesListFilter.propTypes = {
}

export default SalesListFilter
